export default "__VITE_ASSET__BLPhOwMi__"